<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">اتصل بنا</a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3">اتصل بنا </h1>

                        <p>
                            هاتف مباشر :
                            <a href="tel:16582">16582</a>
                            - <a href="tel:15340">15340</a>
                            - <a href="tel:15341">15341</a>
                            - <a href="tel:02-22632087">02/22632087</a>
                            - <a href="tel:02-24004400">02/24004400</a>
                        </p>
                        <p>الموقع الكترونى:
                            <a href="https://cso.moi.gov.eg">https://cso.moi.gov.eg</a>
                        </p>
                        <p>رمز البريد الكترونى:
                            <a href="#">csoinfo@moi.gov.eg</a>  
                        </p>
                        <p>فاكس:
                            <a href="#">02/22619435</a>  
                            - <a href="#">02/22619436</a>
                        </p>
                    </div>
                    <div class="col-md-9 map justify-content-center row"><iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.7886191567827!2d31.288328999999997!3d30.071593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583fbd2a91cc79%3A0x9b6d9192ae8774b6!2z2YXYtdmE2K3YqSDYp9mE2KfYrdmI2KfZhCDYp9mE2YXYr9mG2YrYqQ!5e0!3m2!1sar!2seg!4v1655916060045!5m2!1sar!2seg"
                            width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <br/>
                </div>

            </div>
        </div>
    </section>



</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'IdealCentersComp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
}
</script>